import { render, staticRenderFns } from "./administration.vue?vue&type=template&id=5bb95dd3&scoped=true"
import script from "./administration.vue?vue&type=script&lang=js"
export * from "./administration.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=5bb95dd3&prod&scoped=true&lang=css&external"
import style1 from "./administration.vue?vue&type=style&index=1&id=5bb95dd3&prod&scoped=true&lang=css"
import style2 from "./administration.vue?vue&type=style&index=2&id=5bb95dd3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb95dd3",
  null
  
)

export default component.exports